<template>
    <div>
        <!-- Filtro -->
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <az-input label="Layout do arquivo" type="select" optionsMode="json"
                            placeholder="Selecione o layout do arquivo" :optionsList="[
                                { id: '1', search: 'Rede' },
                                { id: '2', search: 'GETNET' },
                                { id: '3', search: 'Stone' },
                                // { id: '4', search: 'Cielo' },
                                { id: '5', search: 'Layout Customizado' }
                            ]" optionsData="id" optionsDisplay="search" required :validate="validate"
                            v-model="layout.id" />
                    </div>
                    <template v-if="layout.id == 5">
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <az-input label="Layout Customizado" type="select" optionsMode="aql"
                                service="layout-cartao-credito.index" :optionsParm="{ ativos: true }"
                                placeholder="Selecione o layout do arquivo" optionsData="id_layout_cartao_credito"
                                optionsDisplay="search" required :validate="validate"
                                v-model="layout.id_layout_customizado" />
                        </div>
                    </template>
                    <div class="col col-12 col-md-2 d-flex flex-column mt-4">
                        <az-submit color="outline-primary" @click="upload()">Carregar Arquivo</az-submit>
                    </div>
                    <div class="col col-12 col-md-2 d-flex flex-column mt-4" v-if="conciliacaoData">
                        <az-submit color="success" @click="verificaConfirmar()">Confirmar conciliação</az-submit>
                    </div>
                    <div class="col col-12 col-md-2 d-flex flex-column mt-4">
                        <print-export printid="lista-lancamentos" pagina="conc-cartao" :parms="parms_relat_linkados"></print-export>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && conciliacaoData"></div>
            <div class="determinate" v-else></div>
        </div>

        <!-- Filtro por Coluna -->
        <filtro-por-coluna ref="filtro" />

        <div id="lista-lancamentos">

            <template v-if="listaConsolidado.length">
                <div class="text-center bg-info w-full p-2 mb-2" style="cursor: pointer;" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                    <span>Consolidado</span>
                    <i class="fas fa-chevron-down ml-2"></i>
                </div>

                <table class="table table-hover table-sm table-responsive-md bg-white small collapse" id="collapseExample">
                    <thead>
                        <tr>
                            <th>Bandeira</th>
                            <th>Forma Pagamento</th>
                            <th class="text-right">Total Líquido</th>
                            <th class="text-right">Total a Conciliado</th>
                            <th class="text-right">Total a Conciliar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listaConsolidado" :key="idx">
                            <td>{{ item.bandeiraCartao }}</td>
                            <td>{{ item.formaPagamento }}</td>
                            <td class="text-right">
                                <span class="badge badge-secondary">{{ item.quantidade }}</span>
                                {{ $util.formatMoeda(item.totalLiquido) }}
                            </td>
                            <td class="text-right">
                                <span class="badge badge-secondary">{{ item.quantidadeConciliado }}</span>
                                {{ $util.formatMoeda(item.totalConciliado) }}
                            </td>
                            <td class="text-right">
                                <i class="fas fa-check-circle text-success mr-2" v-if="item.ok"></i>
                                <i class="fas fa-exclamation-circle text-danger mr-2" v-if="!item.ok"></i>
                                <span class="badge badge-secondary">{{ item.quantidadeConciliar }}</span>
                                {{ $util.formatMoeda(item.totalConciliar) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>

            <template v-if="conciliacaoData && lista.length">
                <table class="table table-hover table-responsive-md bg-white small cabecalho-fixo">
                    <thead>
                        <tr>
                            <th colspan="14" class="text-center bg-warning">Detalhes do Arquivo</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>Receb</th>
                            <th>Emissão</th>
                            <th>
                                <a href="#" @click.prevent="filtrar_coluna('estabelecimento', 'Estabelecimento')" class="card-link">
                                    Estab
                                </a>
                            </th>
                            <th>
                                <a href="#" @click.prevent="filtrar_coluna('maquina', 'Máquina')" class="card-link">
                                    Máquina
                                </a>
                            </th>
                            <th>
                                <a href="#" @click.prevent="filtrar_coluna('status', 'Status')" class="card-link">
                                    Status
                                </a>
                            </th>
                            <th>
                                <a href="#" @click.prevent="filtrar_coluna('formaPagamento', 'Forma Pagamento')" class="card-link">
                                    Forma Pagamento
                                </a>
                            </th>
                            <th>
                                <a href="#" @click.prevent="filtrar_coluna('bandeiraCartao', 'Bandeira')" class="card-link">
                                    Bandeira
                                </a>
                            </th>
                            <th>NSU/Autorização</th>
                            <th>Parcela</th>
                            <th class="text-right">Valor Bruto</th>
                            <th class="text-right">Valor Desconto</th>
                            <th class="text-right">Valor Liquido</th>
                            <th class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-primary" style="line-height: 10px;">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                                Total do Arquivo
                                <span class="badge badge-secondary" title="Quanntidade de itens">{{ conciliacaoData.items.length }}</span>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="text-right">{{ $util.formatMoeda(conciliacaoData.valorTotalBruto) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(conciliacaoData.valorTotalDesconto) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(conciliacaoData.valorTotalLiquido) }}</th>
                            <th class="text-center"></th>
                        </tr>

                        <tr class="table-info" style="line-height: 10px;" v-if="filtros && filtros.length">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                                Total Filtrado
                                <span class="badge badge-secondary" title="Quanntidade de itens">{{ lista_filtrada.length }}</span>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="text-right">{{ $util.formatMoeda(total_campo('valorBruto')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(total_campo('valorDesconto')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(total_campo('valorLiquido')) }}</th>
                            <th class="text-center"></th>
                        </tr>

                        <tr class="table-success" style="line-height: 10px;">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                                Total a conciliar
                                <span class="badge badge-secondary" title="Quanntidade de itens">{{ conciliacaoData.contadorConciliado }}</span>
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="text-right">
                                {{
                                    $util.formatMoeda(
                                        conciliacaoData.valorConciliadoBruto
                                    )
                                }}
                            </th>
                            <th class="text-right">
                                {{
                                    $util.formatMoeda(
                                        conciliacaoData.valorConciliadoDesconto
                                    )
                                }}
                            </th>
                            <th class="text-right">
                                {{
                                    $util.formatMoeda(
                                        conciliacaoData.valorConciliadoLiquido
                                    )
                                }}
                            </th>
                            <th class="text-center"></th>
                        </tr>

                        <template v-for="(item, idx) in lista_filtrada">
                            <tr :key="idx" v-if="true">
                                <td class="text-nowrap">
                                    <a href="#" class="text-secondary mr-2" @click.prevent="item.expand = !item.expand">
                                        <i class="far fa-plus-square" aria-hidden="true" v-if="!item.expand"></i>
                                        <i class="far fa-minus-square" aria-hidden="true" v-if="item.expand"></i>
                                    </a>
                                </td>
                                <td>
                                    {{
                                        $util.getFormatDate(
                                            item.dataRecebimento,
                                            "DD/MM/YYYY"
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        $util.getFormatDate(
                                            item.dataOriginalVenda,
                                            "DD/MM/YYYY"
                                        )
                                    }}
                                </td>
                                <td>
                                    <a href="#" @click.prevent="filtrar_coluna_valor('estabelecimento', 'Estabelecimento', item)" class="card-link">
                                        {{ item.estabelecimento }}
                                    </a>
                                </td>
                                <td>
                                    <a href="#" @click.prevent="filtrar_coluna_valor('maquina', 'Máquina', item)" class="card-link">
                                        {{ item.maquina }}
                                    </a>
                                </td>
                                <td>
                                    <i class="fas fa-check-circle text-success" v-if="item.conciliar"></i>
                                    <i class="fas fa-info-circle text-primary" v-else-if="
                                        !item.conciliar && item.conciliado
                                    "></i>
                                    <i class="fas fa-times-circle text-warning" v-else-if="
                                        !item.conciliar &&
                                        item.lancamentos.length
                                    "></i>
                                    <i class="fas fa-exclamation-circle text-danger" v-else></i>

                                    <a href="#" @click.prevent="filtrar_coluna_valor('status', 'Status', item)" class="card-link">
                                        {{ item.status }} 
                                    </a>

                                    <span v-if="!temBaixa(item.lancamentos) && item.conciliar" class="text-muted">(não baixado)</span>
                                </td>
                                <td>
                                    <a href="#" @click.prevent="filtrar_coluna_valor('formaPagamento', 'Forma Pagamento', item)" class="card-link">
                                        {{ item.formaPagamento }}
                                    </a>
                                </td>
                                <td>
                                    <a href="#" @click.prevent="filtrar_coluna_valor('bandeiraCartao', 'Bandeira', item)" class="card-link">
                                        {{ item.bandeiraCartao }}
                                    </a>
                                </td>
                                <td>
                                    {{ item.nsu }}<br />
                                    {{ item.numeroAutorizacao }}
                                </td>
                                <td>
                                    {{ item.parcela }}
                                </td>
                                <td class="text-right text-nowrap" :class="item.conciliado
                                    ? 'text-primary'
                                    : !item.conciliar
                                        ? 'text-danger'
                                        : 'text-success'
                                    ">
                                    {{ $util.formatMoeda(item.valorBruto) }}
                                </td>
                                <td class="text-right text-nowrap" :class="item.conciliado
                                    ? 'text-primary'
                                    : !item.conciliar
                                        ? 'text-danger'
                                        : 'text-success'
                                    ">
                                    {{ $util.formatMoeda(item.valorDesconto) }}
                                </td>
                                <td class="text-right text-nowrap" :class="item.conciliado
                                    ? 'text-primary'
                                    : !item.conciliar
                                        ? 'text-danger'
                                        : 'text-success'
                                    ">
                                    {{ $util.formatMoeda(item.valorLiquido) }}
                                </td>
                                <td class="text-center">
                                    <span data-toggle="tooltip" data-placement="top"
                                        :title="'Conciliar. (' + item.nsu + ')'" v-if="item.conciliar || item.conciliado">
                                        <a href="#">
                                            <i class="fas fa-check-square"></i>
                                        </a>
                                    </span>
                                    <span data-toggle="tooltip" data-placement="top" title="Lançamento não conciliado."
                                        v-else>
                                        <a href="#">
                                            <i class="far fa-square"></i>
                                        </a>
                                    </span>
                                </td>
                            </tr>

                            <template v-if="item.expand">
                                <tr v-for="(lanc, idx2) in item.lancamentos" :key="'d' + idx + idx2"
                                    style="line-height: 10px;" class="bg-light">
                                    <td></td>
                                    <td title="Data de Vencimento">
                                        {{ $util.getFormatDate(lanc.dt_vencimento, "DD/MM/YYYY") }}
                                    </td>
                                    <td title="Data de Emissão">
                                        {{ $util.getFormatDate(lanc.dt_emissao, "DD/MM/YYYY") }}
                                    </td>
                                    <td colspan="5">
                                        {{ lanc.st_descricao }}
                                        <div v-if="lanc.baixa && lanc.baixa.st_memo_extrato" class="mt-1 small text-muted">
                                            {{ lanc.baixa.st_memo_extrato }}
                                        </div>
                                    </td>
                                    <td>
                                        <span href="#" click2="abrir_lancamento(lanc)" title="Id do Lançamento">
                                            L: #{{ lanc.id_lancamento }}
                                        </span>
                                        <span class="badge badge-secondary" v-if="lanc.in_parcela > 0">
                                            {{ lanc.in_parcela }}/{{ lanc.in_total_parcelas }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="lanc.baixa" title="Id da Baixa">
                                            B: #{{ lanc.baixa.id_baixa }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(lanc.dc_valor) }}
                                    </td>
                                    <td class="text-center" colspan="2">
                                        <span v-if="lanc.baixa" title="Data da Baixa">
                                            B: {{ $util.getFormatDate(lanc.baixa.dt_baixa, "DD/MM/YYYY") }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </template>

            <template v-else>
                <az-empty-state />
            </template>

        </div>

        <div class="modal fade" id="recebimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Realizar baixa</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <div class="alert alert-warning" role="alert">
                                    <strong>Atenção!</strong><br /> Existe(em) <strong>{{ baixa.contador }}</strong> lançamento(s) sem baixa, totalizando <strong>{{ $util.formatMoeda(baixa.valor_total) }}</strong>.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input type="date" sizing="sm" label="Data" :validate="validate" required
                                    v-model="baixa.dt_baixa" />
                            </div>
                        </div>

                        <template v-if="baixa.bandeiras && baixa.bandeiras.length >= 1">
                            <div class="row" v-for="(bandeira, idx) in baixa.bandeiras" :key="idx">
                                <div class="col col-6">
                                    <az-input label="Bandeira" sizing="sm" v-model="bandeira.search" :readonly="true" :edicao="false" />
                                </div>
                                <div class="col col-6">
                                    <az-input label="Selecione a conta" sizing="sm" :validate="validate" type="select" optionsMode="aql"
                                        service="contas.index" optionsData="id_conta" optionsDisplay="search"
                                        :optionsParm="{ ativas: true }" required v-model="bandeira.id_conta" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="confirmarRecebimento()">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Dispatch -->
        <az-dispatch ref="dispatchModal" titulo="Conciliando informações" @refresh="concilado()" />
    </div>
</template>

<script>
// import * as moment from "moment";
import _ from "lodash";
import $ from "jquery";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzDispatch from "../../util/AzDispatch.vue";
import FiltroPorColuna from '../../relatorios/shared/FiltroPorColuna.vue';
import PrintExport from '../../shared/PrintExport.vue';

export default {
    data() {
        return {
            validate: false,
            conciliacaoData: null,
            layout: {
                id: '',
                id_layout_customizado: '',
            },
            baixa: {
                dt_baixa: null,
                id_conta: null,
                valor_total: 0,
                contador: 0,
                bandeiras: [],
            },
            filtros: [],
        };
    },
    components: {
        AzEmptyState,
        AzSubmit,
        AzDispatch,
        AzInput,
        FiltroPorColuna, 
        PrintExport, 
    },

    methods: {
        abrir_lancamento () { 
            //
        },

        total_campo (campo) { 
            return this.lista_filtrada.reduce((acc, item) => {
                return acc + item[campo];
            }, 0);
        },

        filtrar_coluna_valor (coluna, titulo, item) { 

            this.$refs.filtro.addFiltroModal(
                [item],
                coluna,
                titulo,
                true, 
            );

        },

        filtrar_coluna (coluna, titulo) { 
            this.$refs.filtro.addFiltroModal(this.lista, coluna, titulo);
        },

        temBaixa(lancamentos) {
            return lancamentos.some(lanc => lanc.baixa);
        },

        upload() {
            this.validate = false;
            if (!this.layout) {
                this.validate = true;
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o layout do arquivo",
                    life: 3000
                });
                return;
            }

            var downloadAnchorNode = document.createElement("input");
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.onchange = () => {
                this.posUpload(downloadAnchorNode);
            };
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
        },
        posUpload(el) {
            var file = el.files[0];
            if (file) {
                var reader = new FileReader();

                const fileName = file.name;

                reader.readAsText(file, "ISO-8859-1");

                reader.onload = evt => {
                    this.$store.commit("loading", true);
                    this.$util
                        .loadItem(this, {
                            service: "financeiro.conciliacao_cartao",
                            func: "conciliacao_cartao",
                            parms: {
                                csv: evt.target.result,
                                fileName: fileName,
                                layout: this.layout,
                            }
                        })
                        .then(res => {
                            //console.log(res);
                            this.conciliacaoData = res;
                        })
                        .finally(() => {
                            this.$store.commit("loading", false);
                        });
                };

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                };
            }
        },

        verificaConfirmar() {
            this.baixa.dt_baixa = null;
            this.baixa.id_conta = null; 

            const lancSemBaixa = this.conciliacaoData.items.filter(
                item => item.conciliar && item.lancamentos.some(lanc => !lanc.baixa)
            );

            if (lancSemBaixa && lancSemBaixa.length > 0) {
                if (lancSemBaixa[0].dataRecebimento) {
                    this.baixa.dt_baixa = lancSemBaixa[0].dataRecebimento;
                }

                let bandeiras = _.groupBy(lancSemBaixa.reduce((acc, item) => {
                    return acc.concat(item.lancamentos);
                }, []), 'bandeira_cartao.id_bandeira_cartao');

                bandeiras = Object.keys(bandeiras).map(key => {
                    const bandeiraCartao = _.get(bandeiras, [key, 0, 'bandeira_cartao'], null);
                    const forma = bandeiraCartao
                        ? (bandeiraCartao.ch_tipo == 'D' ? 'Cartão de Débito - ' : 'Cartão de Crédito - ')
                        : '';

                    return {
                        id_bandeira_cartao: key,
                        search: forma + _.get(bandeiraCartao, 'search', 'Pix/Sem bandeira'),
                        id_conta: _.get(bandeiraCartao, 'bandeira_cartao_unidade.id_conta', null),
                        sem_bandeira: !bandeiraCartao,
                    };
                });

                this.baixa.bandeiras = bandeiras;

                const idConta = _.get(lancSemBaixa[0], "lancamentos.0.bandeira_cartao.bandeira_cartao_unidade.id_conta", null);
                if(idConta) {
                    this.baixa.id_conta = idConta;
                }

                const total = lancSemBaixa.reduce((acc, item) => {
                    return acc + item.lancamentos.reduce((acc2, lanc) => {
                        return acc2 + (lanc.baixa ? 0 : lanc.dc_valor);
                    }, 0);
                }, 0);

                const contador = lancSemBaixa.reduce((acc, item) => {
                    return acc + item.lancamentos.filter(lanc => !lanc.baixa).length;
                }, 0);

                this.baixa.contador = contador;
                this.baixa.valor_total = total;

                $("#recebimentoModal").modal("show");
                return;
            }

            this.confirm();
        },

        confirmarRecebimento() {
            this.conciliacaoData.baixa = this.baixa;
            $("#recebimentoModal").modal("hide");
            this.confirm();
        },

        confirm() {
            this.$refs.dispatchModal.executar(
                "conciliacao_cartao_confirmar",
                "financeiro.conciliacao_cartao_confirmar",
                {
                    json: this.conciliacaoData
                },
                "conciliacao-cartao-confirmar"
            );
        },
        cancel() {
            this.conciliacaoData = null;
        },
        concilado() {
            this.conciliacaoData = null;
            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Conciliação concluída com sucesso.",
                life: 3000
            });
        }
    },
    computed: {
        parms_relat_linkados: function () { 
            return { 
                lancamento_id: this.lista_filtrada.flatMap(item => item.lancamentos ? item.lancamentos.map(lanc => lanc.id_lancamento) : []),
                baixa_id: this.lista_filtrada.flatMap(item => item.lancamentos ? item.lancamentos.flatMap(lanc => lanc.baixa ? [lanc.baixa.id_baixa] : []) : []),
            };
        },

        lista: function () {
            if (!this.conciliacaoData) return [];

            return this.conciliacaoData.items;
        },

        lista_filtrada: function () { 
            return this.lista.filter(item => {
                if (!this.filtros.length) return true;

                let nok = this.filtros.filter(filtro => {
                    if (filtro.valor.length > 1) {
                        if ( filtro.tipo == 'E' ) {
                        return filtro.valor.find(vl => {
                            return item[filtro.campo.name] == vl;
                        });
                        } else {
                        return !filtro.valor.find(vl => {
                            return item[filtro.campo.name] == vl;
                        });
                        }
                    } else {
                        if ( filtro.tipo == 'E' ) {
                        return item[filtro.campo.name] == filtro.valor;
                        } else {
                        return item[filtro.campo.name] != filtro.valor;
                        }
                    }
                });

                return !nok.length;
            });
        },

        listaConsolidado: function () {
            if (!this.conciliacaoData) return [];

            if (!this.conciliacaoData.consolidado) return [];

            return this.conciliacaoData.consolidado;
        }
    },
    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro" },
            {
                name: "Conciliação cartão de crédito",
                path: "/financeiro/conciliacao-cartao"
            }
        ]);
    }
};
</script>
